import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";

export const useImageErrorTracking = (): void => {
  useEffect(() => {
    const handleImageError = (event: Event) => {
      const target = event.target as HTMLImageElement;
      const dataError = target.dataset.error;
      const originalImageUrl = target.dataset.originalimageurl;
      target.removeAttribute("data-error");
      target.removeAttribute("data-originalimageurl");
      if (originalImageUrl?.trim().length) {
        datadogRum.addError(new Error("Image failed to load"), {
          imageUrl: originalImageUrl,
          page: window.location.href,
          ...(dataError ? JSON.parse(dataError) : {}),
        });
      }
    };
    const observeImages = (parent: HTMLElement) => {
      const images: NodeListOf<HTMLImageElement> =
        parent.querySelectorAll("img");
      images.forEach((img) => {
        img.addEventListener("error", handleImageError);
      });
    };
    observeImages(document.body);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLImageElement) {
            node.addEventListener("error", handleImageError);
          } else if (node instanceof HTMLElement) {
            observeImages(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
};
